// Extension methods for LobbyScene to add image upload functionality

export function addImageUploadMethods(LobbyScene) {
    /**
     * Create image upload UI for quick play mode
     */
    LobbyScene.prototype.createImageUploadUI = function() {
        // Create upload button area
        const uploadX = 1500;
        const uploadY = 300;
        
        // Title
        this.add.text(uploadX, uploadY - 40, 'CUSTOM AVATAR', {
            fontSize: '20px',
            fontFamily: 'Courier New',
            color: '#00ff00',
            fontWeight: 'bold'
        }).setOrigin(0.5);
        
        // Upload button background
        const uploadBg = this.add.rectangle(uploadX, uploadY + 20, 200, 60, 0x000000, 0.5);
        uploadBg.setStrokeStyle(2, 0x00ff00);
        uploadBg.setInteractive({ useHandCursor: true });
        
        // Upload button text
        const uploadText = this.add.text(uploadX, uploadY + 20, 'UPLOAD IMAGE', {
            fontSize: '16px',
            fontFamily: 'Courier New',
            color: '#ffffff'
        }).setOrigin(0.5);
        
        // Preview area
        this.imagePreviewBg = this.add.rectangle(uploadX, uploadY + 120, 64, 64, 0x000000, 0.3);
        this.imagePreviewBg.setStrokeStyle(1, 0x00ff00);
        
        // Preview text (shown when no image)
        this.previewText = this.add.text(uploadX, uploadY + 120, '32x32', {
            fontSize: '12px',
            fontFamily: 'Courier New',
            color: '#666666'
        }).setOrigin(0.5);
        
        // Handle upload button click
        uploadBg.on('pointerdown', () => {
            this.triggerImageUpload();
        });
    };
    
    /**
     * Trigger file upload dialog
     */
    LobbyScene.prototype.triggerImageUpload = function() {
        // Create hidden file input
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        fileInput.style.display = 'none';
        
        fileInput.addEventListener('change', (event) => {
            const file = event.target.files[0];
            if (file) {
                this.processUploadedImage(file);
            }
            document.body.removeChild(fileInput);
        });
        
        document.body.appendChild(fileInput);
        fileInput.click();
    };
    
    /**
     * Process uploaded image and resize to 32x32
     */
    LobbyScene.prototype.processUploadedImage = function(file) {
        const reader = new FileReader();
        
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                // Create canvas for resizing
                const canvas = document.createElement('canvas');
                canvas.width = 32;
                canvas.height = 32;
                const ctx = canvas.getContext('2d');
                
                // Disable smoothing for pixel art style
                ctx.imageSmoothingEnabled = false;
                
                // Draw and resize image to 32x32
                ctx.drawImage(img, 0, 0, 32, 32);
                
                // Convert canvas to texture
                const textureKey = 'custom_player_avatar';
                if (this.textures.exists(textureKey)) {
                    this.textures.remove(textureKey);
                }
                
                this.textures.addCanvas(textureKey, canvas);
                
                // Store for game use
                this.customPlayerImage = textureKey;
                
                // Show preview
                this.showImagePreview(textureKey);
                
                // Store in registry for RaceScene
                this.registry.set('customPlayerImage', textureKey);
                
                // Notify user
                this.addMessage('Custom avatar uploaded successfully!');
            };
            img.src = e.target.result;
        };
        
        reader.readAsDataURL(file);
    };
    
    /**
     * Show uploaded image preview
     */
    LobbyScene.prototype.showImagePreview = function(textureKey) {
        // Hide preview text
        if (this.previewText) {
            this.previewText.setVisible(false);
        }
        
        // Remove old preview if exists
        if (this.imagePreview) {
            this.imagePreview.destroy();
        }
        
        // Create new preview
        this.imagePreview = this.add.image(1500, 420, textureKey);
        this.imagePreview.setDisplaySize(64, 64);
    };
}